import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button, Select } from "antd";
import { useDispatch } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import isEmpty from "lodash/isEmpty";

import { doSetupAccount, doGetProfile } from "../../../modules/auth/stores/thunk";
import { INDUSTRIES, NUM_OF_DRIVERS } from "../../../constants";
import "./Auth.scss";
import { setCountryCookie } from "../../../utils/helper";

const SetupAccountForm = ({ user, countryCodeInit }) => {
  const [countryPhone, setCountryPhone] = useState();
  const dispatch = useDispatch();
  const handleSubmit = async values => {
    const params = { ...values };
    params.phone =
      !isEmpty(values.phone) && countryPhone?.dialCode !== values.phone
        ? `${values.phone.includes("+") ? "" : "+"}${values.phone}`
        : null;
    await dispatch(doSetupAccount(params));
    await dispatch(doGetProfile());
  };
  return (
    <div className="SignUpForm SetupAccountForm">
      <Form
        scrollToFirstError
        layout="vertical"
        hideRequiredMark
        colon={false}
        onFinish={handleSubmit}
        initialValues={{
          name: user?.company?.name,
        }}>
        <div className="Logo">
          <Link to="/">
            <img
              src={`/logo-${window.location.origin.includes("nordicrouting.se") ? "nordicrouting" : "parcelizer"}.svg`}
              alt="logo"
            />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">Setup your account</div>
          <div className="SubTitle">
            This is your first time logging in Parcelizer. Please let us know briefly about your company.
          </div>
        </div>
        <div className="FormContent">
          <Form.Item label="Company Name" name="name" rules={[{ required: true, message: "Required" }]}>
            <Input size="large" placeholder="Company Name" />
          </Form.Item>
          <Form.Item label="Phone" name="phone" rules={[{ required: true, message: "Required" }]}>
            <PhoneInput
              country={countryCodeInit}
              enableSearch
              disableSearchIcon
              onChange={(value, country) => {
                setCountryPhone(country);
                setCountryCookie(value, country, user);
              }}
            />
          </Form.Item>
          <Form.Item
            label="What best describes your company?"
            name="industry"
            rules={[{ required: true, message: "Required" }]}>
            <Select size="large" placeholder="What best describes your company?">
              {INDUSTRIES.map(item => (
                <Select.Option key={item} value={item}>
                  {item}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Number of Drivers" name="numOfDrivers" rules={[{ required: true, message: "Required" }]}>
            <Select size="large" placeholder="Number of Drivers">
              {NUM_OF_DRIVERS.map(item => (
                <Select.Option key={item} value={item}>
                  {item}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            Continue
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default SetupAccountForm;
